// Use the local Webpack dev-server proxy only for local development.
// All hosted frontends must call the dedicated API App Service, not the
// React SPA host (which otherwise returns index.html for unknown /api paths).
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);
const API_BASE = LOCAL_HOSTS.has(window.location.hostname)
  ? '/api'
  : 'https://api.advisor.metricus.com/api';

async function parseResponse(res){
  if(res.status===204) return null;
  const text=await res.text();
  let body=null;
  try{body=text?JSON.parse(text):null;}catch(_){body=text;}
  const contentType=res.headers.get('content-type')||'';
  if(contentType.includes('text/html') || (typeof body==='string' && /^\s*<!doctype html|^\s*<html/i.test(body))){
    throw new Error('API request returned HTML instead of JSON. Check that the deployed frontend is calling https://api.advisor.metricus.com rather than the website.');
  }
  if(!res.ok){
    const err=new Error(body?.error||`API request failed (${res.status})`);
    err.status=res.status; err.body=body; throw err;
  }
  return body;
}
export async function apiFetch(path,options={}){
  const headers={...(options.body?{'Content-Type':'application/json'}:{}),...(options.headers||{})};
  const res=await fetch(`${API_BASE}${path}`,{...options,headers,credentials:'include'});
  return parseResponse(res);
}
export async function apiHealth(timeoutMs=10000){
  const controller=new AbortController(),id=setTimeout(()=>controller.abort(),timeoutMs);
  try{
    const res=await fetch(`${API_BASE}/health`,{signal:controller.signal,credentials:'include'});
    return res.ok?await res.json():null;
  }catch(_){return null;}finally{clearTimeout(id);}
}
export const authApi={
  session:()=>apiFetch('/session'),
  login:(email,password)=>apiFetch('/auth/login',{method:'POST',body:JSON.stringify({email,password})}),
  signup:(payload)=>apiFetch('/auth/signup',{method:'POST',body:JSON.stringify(payload)}),
  logout:()=>apiFetch('/auth/logout',{method:'POST'}),
  oauthUrl:(provider)=>`${API_BASE}/auth/${encodeURIComponent(provider)}/start`,
};

// Workspace ownership and invitations: authenticated, same-origin session requests.
export const workspaceApi={
 details:()=>apiFetch('/workspace/manage'),
 rename:(payload)=>apiFetch('/workspace/manage',{method:'PUT',body:JSON.stringify(payload)}),
 available:()=>apiFetch('/workspace/available'),
 switchTo:(workspaceId)=>apiFetch('/workspace/switch',{method:'POST',body:JSON.stringify({workspaceId})}),
 invite:(email)=>apiFetch('/workspace/invitations',{method:'POST',body:JSON.stringify({email})}),
 revoke:(id)=>apiFetch(`/workspace/invitations/${encodeURIComponent(id)}`,{method:'DELETE'}),
 remove:(id)=>apiFetch(`/workspace/members/${encodeURIComponent(id)}`,{method:'DELETE'}),
 setRole:(id,role)=>apiFetch(`/workspace/members/${encodeURIComponent(id)}/role`,{method:'PATCH',body:JSON.stringify({role})}),
 accept:(inviteCode)=>apiFetch('/workspace/accept-invitation',{method:'POST',body:JSON.stringify({inviteCode})}),
};
